/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureSummaryListRequest {
    getFixupPrototypeFunction() { return TagPostureSummaryListRequest.fixupPrototype; }

    static newInstance(model: Partial<TagPostureSummaryListRequest>): TagPostureSummaryListRequest {
        let obj = Object.assign(new TagPostureSummaryListRequest(), model);
        TagPostureSummaryListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureSummaryListRequest>): TagPostureSummaryListRequest {
        if (!model) return null;
        return TagPostureSummaryListRequest.newInstance(<TagPostureSummaryListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureSummaryListRequest) {
        if (!obj) return;

        models.TagPostureSummaryListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureSummaryListRequest): boolean {
        Object.setPrototypeOf(obj, TagPostureSummaryListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.TagPostureContext.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.TagPostureSummarySortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.TagPostureSummarySortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.TagPostureContext;

}
